import * as THREE from 'three';

export const createConveyorSystem = (
    scene: THREE.Scene,
    materials: any,
    componentsRef: React.MutableRefObject<Array<{
        mesh: THREE.Mesh;
        solidMaterial: THREE.Material;
        wireframeMaterial: THREE.Material;
    }>>
) => {
    const conveyorBeltLength = 8;
    const numConveyorSegments = 3;
    const conveyorSpacing = 1;

    for (let i = 0; i < numConveyorSegments; i++) {
        const conveyorBeltGroup = new THREE.Group();
        conveyorBeltGroup.position.set(
            (i - (numConveyorSegments - 1) / 2) * (conveyorBeltLength + conveyorSpacing),
            0,
            0
        );

        // 流水线平台
        const beltGeometry = new THREE.BoxGeometry(conveyorBeltLength, 0.5, 3);
        const beltMesh = new THREE.Mesh(beltGeometry, materials.solidSilver.clone());
        beltMesh.position.set(0, 0.25, 0);
        conveyorBeltGroup.add(beltMesh);
        componentsRef.current.push({
            mesh: beltMesh,
            solidMaterial: materials.solidSilver.clone(),
            wireframeMaterial: materials.wireframeCyan.clone()
        });

        // 支撑腿
        const legGeometry = new THREE.BoxGeometry(0.5, 2, 0.5);
        const legOffsets = [-conveyorBeltLength / 2 + 0.5, conveyorBeltLength / 2 - 0.5];
        legOffsets.forEach(offset => {
            const leg = new THREE.Mesh(legGeometry, materials.solidBlue.clone());
            leg.position.set(offset, -1, 1);
            conveyorBeltGroup.add(leg);
            componentsRef.current.push({
                mesh: leg,
                solidMaterial: materials.solidBlue.clone(),
                wireframeMaterial: materials.wireframeCyan.clone()
            });
        });

        scene.add(conveyorBeltGroup);
    }
}; 